import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        users: [],
        videos: [],
        footerMenu: [],
        client_videos: [],
        categories: [],
        playlists: [],
    },
    getters: {
        isLoggedIn: state => !!state.token,
        users: state => state.users,
        videos: state => state.videos,
        client_videos: state => state.client_videos,
        categories: state => state.categories
    },
    mutations: {
        LOAD_USERS(state, users) {
            state.users = users;
        },
        DELETE_USER(state, user) {
            state.users = state.users.filter(el => el._id != user._id);
        },
        LOAD_VIDEOS(state, videos) {
            state.videos = videos;
        },
        LOAD_CLIENT_VIDEOS(state, videos) {
            state.client_videos = videos;
        },
        LOAD_FOOTER_MENU(state, footerMenu) {
            state.footerMenu = footerMenu;
        },
        LOAD_CATEGORIES(state, categories) {
            state.categories = categories;
        },
        LOAD_PLAYLISTS(state, playlists) {
            state.playlists = playlists;
        },
        UpdateClientVideos(state, payload) {
            state.client_videos = payload;
        }
    },
    actions: {

        updateClientVideos: ({ commit }, payload) => {
            commit("UpdateClientVideos", payload);
        },

        loadUsers(context) {
            axios
                .get(`${process.env.VUE_APP_API_URL}/api/users`)
                .then(users => {
                    context.commit('LOAD_USERS', users.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadClientplaylists(context) {
            axios
                .get(`${process.env.VUE_APP_API_URL}/api/client/playlists`)
                .then(playlists => {
                    context.commit('LOAD_PLAYLISTS', playlists.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        deleteUser(context, user) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${process.env.VUE_APP_API_URL}/api/users`, { data: user })
                    .then(res => {
                        context.commit('DELETE_USER', user);
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        deleteFooterMenu(context, footerMenu) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${process.env.VUE_APP_API_URL}/api/footer-menu`, { data: footerMenu })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                        console.log(error);
                    });
            });
        },

        deletecategory(context, category) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${process.env.VUE_APP_API_URL}/api/admin/categories`, { data: category })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
        deleteClientCategory(context, category) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${process.env.VUE_APP_API_URL}/api/client/categories`, { data: category })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        updateUser(context, user) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${process.env.VUE_APP_API_URL}/api/users`, user)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        UpdateCategory(context, category) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${process.env.VUE_APP_API_URL}/api/admin/categories`, category)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        UpdateClientCategory(context, category) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${process.env.VUE_APP_API_URL}/api/client/categories`, category)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        updateFooterMenu(context, footerMenu) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${process.env.VUE_APP_API_URL}/api/footer-menu`, footerMenu)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        newUser(context, user) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${process.env.VUE_APP_API_URL}/api/users`, user)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        newCategory(context, category) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${process.env.VUE_APP_API_URL}/api/admin/categories`, category)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        newClientCategory(context, category) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${process.env.VUE_APP_API_URL}/api/client/categories`, category)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        loadVideos(context) {
            axios
                .get(`${process.env.VUE_APP_API_URL}/api/videos`)
                .then(videos => {
                    context.commit('LOAD_VIDEOS', videos.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        loadCategories(context) {
            axios.get(`${process.env.VUE_APP_API_URL}/api/admin/categories`)
                .then(categories => {
                    context.commit("LOAD_CATEGORIES", categories.data);
                })
                .catch(error => {
                    console.log(error)
                })
        },
        loadClientCategories(context) {
            axios.get(`${process.env.VUE_APP_API_URL}/api/client/categories`)
                .then(categories => {
                    context.commit("LOAD_CATEGORIES", categories.data);
                })
                .catch(error => {
                    console.log(error)
                })
        },

        loadUserVideos(context) {
            axios
                .get(`${process.env.VUE_APP_API_URL}/api/clientVideos`)
                .then(videos => {
                    context.commit('LOAD_CLIENT_VIDEOS', videos.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        deleteVideo(context, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${process.env.VUE_APP_API_URL}/api/videos/${id}`)
                    .then(video => {
                        resolve(video);
                    })
                    .catch(error => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        deleteClientVideo(context, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`${process.env.VUE_APP_API_URL}/api/clientVideos/${id}`)
                    .then(video => {
                        resolve(video);
                    })
                    .catch(error => {
                        reject(error);
                        console.log(error);
                    });
            });
        },

        loadFooterMenu(context) {
            axios
                .get(`${process.env.VUE_APP_API_URL}/api/footer-menu`)
                .then(footerMenu => {
                    context.commit('LOAD_FOOTER_MENU', footerMenu.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        newFooterMenu(context, footerMenu) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${process.env.VUE_APP_API_URL}/api/footer-menu`, footerMenu)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
});